import {useEffect, useState, useRef} from 'react';

const POLL_INTERVAL = 100; // ms
const MAX_RETRY = 100; // attempts

export function useWaitForLoadScript(
  callback,
  pollInterval = POLL_INTERVAL,
  maxRetry = MAX_RETRY,
) {
  const [isLoaded, setIsLoaded] = useState(false);
  const attemptsRef = useRef(0);
  const timeoutRef = useRef(null);
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const clearTimer = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };

    if (isLoaded || attemptsRef.current >= maxRetry) {
      clearTimer();

      return;
    }

    const check = () => {
      if (callbackRef.current()) {
        setIsLoaded(true);
        clearTimer();

        return;
      }

      attemptsRef.current += 1;
      if (attemptsRef.current < maxRetry) {
        clearTimer();
        timeoutRef.current = setTimeout(check, pollInterval);
      }
    };

    check();

    return () => {
      clearTimer();
    };
  }, [callbackRef, isLoaded, maxRetry, pollInterval]);

  return isLoaded;
}
